export default __webpack_public_path__ + "static/media/rounded-flag-3x.1284cb56.webp";